import { render, staticRenderFns } from "./countdown-digits.vue?vue&type=template&id=84fcabea"
import script from "./countdown-digits.vue?vue&type=script&lang=js"
export * from "./countdown-digits.vue?vue&type=script&lang=js"
import style0 from "./countdown-digits.vue?vue&type=style&index=0&id=84fcabea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports